import { defaultUrlTransform } from 'react-markdown';

import { mediaUrl } from '../api';

// A stored media path, under today's prefix or the one it had before.
const MEDIA_PATH = /^\/media\//;

/**
 * Resolves URLs in rendered markdown.
 *
 * Article text stores media as a path - `/media/ab/ab12...f0.png` - so that a
 * database moved to another host keeps working. A path alone would be resolved
 * by the browser against the page, and the page is served by the client, not by
 * the API that holds the files; this is where the API host is put back on.
 *
 * Every other URL goes through react-markdown's own sanitising transform
 * untouched, so this cannot become a way to smuggle `javascript:` links in.
 */
export function markdownUrlTransform(url) {
  const safe = defaultUrlTransform(url);

  return MEDIA_PATH.test(safe) ? mediaUrl(safe) : safe;
}
